import * as Preact from 'preact';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * Figma design nodes:
 * Mobile: https://www.figma.com/file/va7snk88pL7TR7F75h7zbt/Design-Files?node-id=9687%3A59485
 * Desktop: https://www.figma.com/file/va7snk88pL7TR7F75h7zbt/Design-Files?node-id=9461%3A51021
 */

export interface Props {
    title: string;
}

export const Component = (p: Props) => (
    <Box
        sx={{
            height: '64px',
            width: '100%',
            padding: { xs: '8px 16px', md: '16px 23px' },
            bgcolor: 'background.paper',
            display: 'flex',
            alignItems: 'center',
            boxSizing: 'border-box',
        }}
    >
        <Typography sx={{ typography: { xs: 'h4', md: 'h3' } }} data-testId="config-panel-title">
            {p.title}
        </Typography>
    </Box>
);
